import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared-imports';

/** Blocking dialog prompting the user to reload after a new console deploy. */
@Component({
  selector: 'app-update-app-dialog',
  standalone: true,
  imports: [...SHARED_IMPORTS],
  templateUrl: './update-app-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UpdateAppDialogComponent {
  private readonly document = inject(DOCUMENT);

  /**
   * Hard-reloads the page to fetch the new Angular bundle.
   * @returns {void}
   */
  refresh(): void {
    this.document.location.reload();
  }
}
